export default "__VITE_ASSET__BLLzOHEj__"